import { ON_NEXT_GAME } from '../state-constants/stateConstants';

export const onNextGame = bool => ({
  type: ON_NEXT_GAME,
  payload: bool,
});



// WEBPACK FOOTER //
// ./src/state-actions/onNextGame.js